export const MESSAGE_ORDER_TO_EXECUTION = 'Wykonano';
